import { jsx } from 'react/jsx-runtime';

/**
 * Polymorphic component for rendering rich text.
 *
 * @defaultValue `React.Fragment`
 * @deprecated This component is deprecated and will be removed in a future version.
 * Use standard HTML elements with Bootstrap classes instead.
 * For HTML string rendering, use dangerouslySetInnerHTML directly.
 */ const RichText = ({ as: Component = 'span', renderChildrenAsHTML = true, children, className, ...rest })=>{
    // Show deprecation warning in development
    if (process.env.NODE_ENV === 'development') {
        console.warn('⚠️  RichText component is deprecated and will be removed in a future version.\n' + 'Please use standard HTML elements with Bootstrap classes instead:\n' + '• For normal content: <span>, <div>, <p>, etc. with className\n' + '• For HTML strings: use dangerouslySetInnerHTML={{__html: htmlString}} directly\n' + '• Apply Bootstrap classes directly to your HTML elements');
    }
    if (renderChildrenAsHTML && typeof children === 'string') {
        /**
         * Only allow strings to be rendered as HTML
         *
         * TODO: [WCDS] Replace with a more fully featured solution
         *  like Contentful's Rich Text Renderer
         */ return jsx(Component, {
            ...rest,
            className: className,
            dangerouslySetInnerHTML: {
                __html: children
            }
        });
    }
    return jsx(Component, {
        ...rest,
        className: className,
        children: children
    });
};

export { RichText };
